import { AppThemeConfiguration } from '/@/shared/themes/app-theme-types';

export const defaultDark: AppThemeConfiguration = {
    app: {},
    mode: 'dark',
};
